/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestUpdateStatusNotificationPreviewResponse
 */
export interface AccessRequestUpdateStatusNotificationPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestUpdateStatusNotificationPreviewResponse
     */
    email?: string | null;
}

/**
 * Check if a given object implements the AccessRequestUpdateStatusNotificationPreviewResponse interface.
 */
export function instanceOfAccessRequestUpdateStatusNotificationPreviewResponse(value: object): value is AccessRequestUpdateStatusNotificationPreviewResponse {
    return true;
}

export function AccessRequestUpdateStatusNotificationPreviewResponseFromJSON(json: any): AccessRequestUpdateStatusNotificationPreviewResponse {
    return AccessRequestUpdateStatusNotificationPreviewResponseFromJSONTyped(json, false);
}

export function AccessRequestUpdateStatusNotificationPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestUpdateStatusNotificationPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function AccessRequestUpdateStatusNotificationPreviewResponseToJSON(json: any): AccessRequestUpdateStatusNotificationPreviewResponse {
    return AccessRequestUpdateStatusNotificationPreviewResponseToJSONTyped(json, false);
}

export function AccessRequestUpdateStatusNotificationPreviewResponseToJSONTyped(value?: AccessRequestUpdateStatusNotificationPreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

